import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import UserDetailsHeader from "../../UserDetailsHeader";
import { STS_SIDE_INFO, USER_LIST } from "../../../../routes/routerPath";
import { getSearchParams } from "../../../../utlis/helpers";
import { useSection } from "../../../../i18n/useSection";
import prerequisites from "../../../../assets/images/HowToTest/TugFront/prerequistes.png";
import seatedGuide from "./sts-guide-seated.svg";
import standingGuide from "./sts-guide-standing.svg";
import { getStsContext } from "./stsAccess";
import InstructionText from "../InstructionText";
import { isProdUsAccount } from "../../../../utlis/measurementModules";
import { pt } from "../../../prodUs/prodUsStrings";
import "./sts.scss";

export default function HowToTestStsSide() {
  const t = useSection("sts");
  const prodUs = isProdUsAccount();
  const navigate = useNavigate();
  if (!getStsContext())
    return <Navigate to={`${USER_LIST}${getSearchParams()}`} replace />;
  return (
    <UserDetailsHeader
      className="measurement-shell"
      onBack={() => navigate(STS_SIDE_INFO + getSearchParams())}
      backLabel={t.back}
    >
      <main className="sts-page measurement-guide">
        <h1>{t.guide_title}</h1>
        <h2>{t.playlist}</h2>
        <div className="sts-playlists">
          {[t.test_guide, t.support_guide, t.general_guide].map(
            (title, index) => (
              <div className="sts-playlist" key={index} aria-disabled="true">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  aria-hidden="true"
                >
                  <circle
                    cx="20"
                    cy="20"
                    r="17"
                    stroke="currentColor"
                    strokeWidth="3"
                  />
                  <path d="M16 13l11 7-11 7z" fill="currentColor" />
                </svg>
                <div>
                  <span>
                    {index + 1}. {title}
                  </span>
                  <small>{t.video_unavailable}</small>
                </div>
              </div>
            ),
          )}
        </div>
        <h2>{t.step_guide}</h2>
        <section className="sts-guide-section">
          <h3>1. {t.prerequisites}</h3>
          <img
            className="sts-equipment"
            src={prerequisites}
            alt={t.equipment_image}
          />
          {[
            [t.chair, t.chair_description],
            [t.phone_stand, t.phone_stand_description],
            [t.support_person, t.support_description],
            [t.disable_wide, t.disable_wide_description],
          ].map(([title, description]) => (
            <div key={title}>
              <h4>{title}</h4>
              <ul>
                <li>{description}</li>
              </ul>
            </div>
          ))}
        </section>
        <section className="sts-guide-section">
          <h3>2. {t.setup}</h3>
          <img
            className="sts-guide-camera"
            src={seatedGuide}
            alt={t.illustration_seated}
          />
          <ul>
            {[1, 2, 3, 4, 5, 6].map((n) => (
              <li key={n}>
                {n === 4 ? (
                  <strong>{t.setup4}</strong>
                ) : (
                  <InstructionText text={t[`setup${n}`]} />
                )}
              </li>
            ))}
          </ul>
        </section>
        <section className="sts-guide-section">
          <h3>3. {t.perform}</h3>
          <img
            className="sts-guide-camera"
            src={standingGuide}
            alt={t.illustration_standing}
          />
          <ul>
            <li>{t.perform_start}</li>
            <li>
              {t.read_steps}
              <ol>
                {[1, 2, 3, 4, 5].map((n) => (
                  <li key={n}>
                    <InstructionText text={t[`script${n}`]} />
                  </li>
                ))}
              </ol>
            </li>
            <li>
              <InstructionText text={t.perform_stop} />
            </li>
            <li>{t.normal_pace}</li>
          </ul>
        </section>
        <section className="sts-guide-section">
          <h3>4. {t.upload}</h3>
          {prodUs ? (
            // Prod_US: nothing uploads after this test; both videos upload after TUG (Front).
            <ul>
              <li>{pt("sts_step4")}</li>
              <li>
                <InstructionText text={t.upload2} warning />
              </li>
            </ul>
          ) : (
            <>
              <div className="sts-upload-illustration" aria-hidden="true">
                <div className="sts-upload-selected">
                  <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
                    <rect
                      x="4"
                      y="4"
                      width="30"
                      height="32"
                      rx="3"
                      fill="#C9C9C9"
                    />
                    <rect
                      x="10"
                      y="8"
                      width="18"
                      height="10"
                      rx="1"
                      fill="#FFFFFF"
                    />
                    <circle cx="32" cy="32" r="10" fill="#3BA55C" />
                    <path
                      d="M27 32l3.5 3.5L37 29"
                      stroke="#FFFFFF"
                      strokeWidth="2.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span>{t.selected}</span>
                </div>
                <p>
                  <InstructionText text={t.selected_note} label />
                </p>
                <span className="sts-upload-label">{t.upload_now}</span>
              </div>
              <ul>
                <li>
                  <InstructionText text={t.upload1} />
                </li>
                <li>
                  <InstructionText text={t.upload2} warning />
                </li>
              </ul>
            </>
          )}
        </section>
      </main>
    </UserDetailsHeader>
  );
}
